package com.cs.ejobin.ui.theme

import androidx.compose.ui.graphics.Color

/**
 * Couleurs principales de l'application eJobin
 * Source : logo officiel
 */
object AppColors {
    val Primary = Color(0xFF0B5FA5)

    val PrimaryDark = Color(0xFF1746C4)
    val PrimaryLight = Color(0xFF5A82FF)

    val Background = Color(0xFFFFFFFF)
    val Surface = Color(0xFFFFFFFF)

    val TextPrimary = Color(0xFF0F172A)
    val TextSecondary = Color(0xFF64748B)
    val Divider = Color(0xFFE5E7EB)

    val Error = Color(0xFFE53935)
    val Success = Color(0xFF2E7D32)
}